let globals;
export function createGlobals() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    const win = window;
    const doc = (_a = window) === null || _a === void 0 ? void 0 : _a.document;
    const location = (_b = win) === null || _b === void 0 ? void 0 : _b.location;
    const localStorage = (_c = win) === null || _c === void 0 ? void 0 : _c.localStorage;
    const navigator = (_d = win) === null || _d === void 0 ? void 0 : _d.navigator;
    const MediaMetadata = (_e = win) === null || _e === void 0 ? void 0 : _e.MediaMetadata;
    const fetchNative = ((_f = win) === null || _f === void 0 ? void 0 : _f.fetch) && ((_g = win) === null || _g === void 0 ? void 0 : _g.fetch.bind(win));
    const history = (_h = win) === null || _h === void 0 ? void 0 : _h.history;
    const amznMusic = (_j = win) === null || _j === void 0 ? void 0 : _j.amznMusic;
    const __REDUX_DEVTOOLS_EXTENSION_COMPOSE__ = ((_k = win) === null || _k === void 0 ? void 0 : _k.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) && ((_l = win) === null || _l === void 0 ? void 0 : _l.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__.bind(win));
    const performance = (_m = win) === null || _m === void 0 ? void 0 : _m.performance;
    const setLocation = (uri) => {
        var _a;
        // @ts-ignore
        (_a = win) === null || _a === void 0 ? void 0 : _a.location = uri;
    };
    globals = {
        __REDUX_DEVTOOLS_EXTENSION_COMPOSE__,
        amznMusic,
        document: doc,
        fetch: fetchNative,
        history,
        localStorage,
        location,
        MediaMetadata,
        navigator,
        performance,
        setLocation,
        window: win,
    };
    return globals;
}
createGlobals();
export { globals };
